import React, { useState, useEffect } from "react";
import "./searchInput.css";

export default function SearchInput({ value, onChange }) {
  const [inputValue, setInputValue] = useState(value);

  // Update local input when prop value changes
  useEffect(() => {
    setInputValue(value);
  }, [value]);

  // Debounce search input
  useEffect(() => {
    const timer = setTimeout(() => {
      if (inputValue !== value) {
        onChange(inputValue);
      }
    }, 400); // 400ms delay

    return () => clearTimeout(timer);
  }, [inputValue, onChange, value]);

  // Handle search button click
  const handleSearch = (e) => {
    e.preventDefault();
    onChange(inputValue);
  };

  return (
    <form className="search-bar" onSubmit={handleSearch}>
      <input
        type="text"
        name="search-bar"
        id="search-bar"
        placeholder="Sök efter gata/område..."
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
      />
      <button type="submit">
        <svg viewBox="0 0 512 512" fill="currentColor" height="1em" width="1em">
          <path d="M416 208c0 45.9-14.9 88.3-40 122.7l126.6 126.7c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208zM208 352c79.5 0 144-64.5 144-144S287.5 64 208 64 64 128.5 64 208s64.5 144 144 144z" />
        </svg>{" "}
        Sök
      </button>
    </form>
  );
}
